
export class VehicleGroup {
    id: number;
    name: string;
    vehiclesSideNumbers: string[];
}
